"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));

var _Checkbox = _interopRequireDefault(require("@micado-digital/react-form/Checkbox"));

var _Input = _interopRequireDefault(require("@micado-digital/react-form/Input"));

var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));

var _de = _interopRequireDefault(require("../../../locals/de.json"));

var _en = _interopRequireDefault(require("../../../locals/en.json"));

var _it = _interopRequireDefault(require("../../../locals/it.json"));

var _Billing = _interopRequireDefault(require("./Billing.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Billing = function Billing(_ref) {
  var customerTaxCode = _ref.customerTaxCode,
      lang = _ref.lang,
      sendBill = _ref.sendBill,
      setCustomerTaxCode = _ref.setCustomerTaxCode,
      setSendBill = _ref.setSendBill;

  var _useContext = (0, _react.useContext)(_CartContext.default),
      cart = _useContext.cart;

  var _ref2 = cart || {},
      _ref2$address = _ref2.address;

  _ref2$address = _ref2$address === void 0 ? {} : _ref2$address;
  var billing = _ref2$address.billing,
      shipping = _ref2$address.shipping;

  var _ref3 = billing || {},
      billingCountryCode = _ref3.countryCode;

  var _ref4 = shipping || {},
      shippingCountryCode = _ref4.countryCode;

  var css = (0, _Billing.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  var countryCode = billingCountryCode !== null && billingCountryCode !== void 0 ? billingCountryCode : shippingCountryCode;
  if (countryCode !== "IT") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.billing, "mco-shop-checkout-billing")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.headline, "mco-shop-checkout__headline")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.checkout.billing.headline",
    l: l
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: l("reactShop.checkout.labels.customerTaxCode"),
    name: "customerTaxCode",
    required: true,
    value: customerTaxCode,
    setValue: function setValue(value) {
      return setCustomerTaxCode(value);
    },
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: sendBill,
    label: l("reactShop.checkout.labels.sendBill"),
    name: "accepted",
    setChecked: setSendBill,
    value: true
  })));
};

var _default = Billing;
exports.default = _default;